/* global axios */
import ApiClient from '../ApiClient';

class AiAssistSettingsAPI extends ApiClient {
  constructor() {
    super('ai_assist', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, payload);
  }
}

export default new AiAssistSettingsAPI();
